import React from "react";
import Header from "../../components/Header/LandingHeader";
import s from "./RegionalRepresentatives.module.scss";
import Table, { ColumnsType } from "antd/es/table";
import LandingFooter from "../../components/LandingFooter/LandingFooter";
import MobileHeader from "../../components/MobileHeader/MobileHeader";
import useWindowDimensions from "../../components/WindowDimentions/WindowDimentions";
import MobileRegionalRepresentatives from "./MobileRegionalRepresentatives";
import PageTitle from "../../components/PageTitle/PageTitle";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons";
import { representatives, TableType } from "./representativesData";

type Props = {};

const RegionalRepresentatives = (props: Props) => {
  const { width } = useWindowDimensions();

  const columns: ColumnsType<TableType> = [
    {
      title: "№",
      dataIndex: "key",
      width: 50,
      align: "center",
    },
    {
      title: "COUNTRIES",
      onHeaderCell: () => ({ className: s.th_countries }),
      dataIndex: "country",
      width: 160,
      render: (_, record) => (
        <div className={s.country_item}>
          <img
            src={record.flag}
            alt={record.country}
            className={s.country_flag_img}
          />

          <div>{record.country}</div>
        </div>
      ),
    },
    {
      title: "COMPANIES",
      onHeaderCell: () => ({ className: s.th_indented }),
      dataIndex: "company",
      width: 400,
      render: (company) => {
        if (!company || typeof company === "string") {
          return "—";
        }

        const hasData =
          company.name || company.phone || company.email || company.address;

        if (!hasData) {
          return <div style={{ marginLeft: "10px", color: "gray" }}>—</div>;
        }

        return (
          <div>
            {company.name && (
              <div className={s.company_item}>
                <span className={s.contact}>Company: </span>
                <strong>{company.name}</strong>
              </div>
            )}

            {company.phone && (
              <div className={s.company_item}>
                <span className={s.contact} title="Phone" aria-label="Phone">
                  <PhoneOutlined className={s.icon} />
                </span>
                {company.phone}
              </div>
            )}

            {company.email && (
              <div className={s.company_item}>
                <span className={s.contact} title="Email" aria-label="Email">
                  <MailOutlined className={s.icon} />
                </span>
                {company.email}
              </div>
            )}

            {company.address && (
              <div className={s.company_item}>
                <span className={s.contact}>Address: </span>
                {company.address}
              </div>
            )}
          </div>
        );
      },
    },
    {
      title: "REPRESENTATIVES",
      onHeaderCell: () => ({ className: s.th_indented }),
      dataIndex: "representative",
      width: 300,
      render: (representative) => (
        <div style={{ marginLeft: "10px" }}>
          {representative ? (
            representative
          ) : (
            <div style={{ color: "gray" }}>—</div>
          )}
        </div>
      ),
    },
  ];

  const data = representatives;

  return (
    <div>
      {width > 600 ? <Header /> : <MobileHeader />}

      <div className={s.content}>
        <PageTitle className={s.h2} eyebrow="About us" title="Regional Representatives - Partners" />

        <div className={s.text}>
          {width > 700 ? (
            <Table<TableType>
              bordered
              columns={columns}
              dataSource={data}
              rowKey="key"
              pagination={false}
              className={s.table}
              footer={() => (
                <div className={s.footer_content}>
                  <span>
                    Middle Corridor Transit Advisory Committee · Regional
                    Representatives (Partners)
                  </span>
                  <span className={s.footer_count}>{data.length} countries</span>
                </div>
              )}
            />
          ) : (
            <MobileRegionalRepresentatives data={data} />
          )}
        </div>
      </div>

      <LandingFooter />
    </div>
  );
};

export default RegionalRepresentatives;
